import NavProvider from "./MenuColor"

import { ScreenProvider } from "library/ScreenContext"
import VideoProvider from "./VideoModalContext"

interface ProvidersProps {
	children: React.ReactNode
}

export default function Providers({ children }: ProvidersProps) {
	return (
		<ScreenProvider>
			<VideoProvider>
				<NavProvider>{children} </NavProvider>
			</VideoProvider>
		</ScreenProvider>
	)
}
